import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import {
  calculateWorkloadSummary,
  type WorkloadEntry
} from '@/domain/review/workload-summary.rules'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'

export function useWorkloadSummary(
  formMethods?: StudentRequestedCoursesFormMethods,
  curriculumCourses?: DesiredEducationCourse[]
) {
  const courseEquivalences = useWatch({
    control: formMethods?.control,
    name: 'courseEquivalences'
  })

  return useMemo(() => {
    const entries: WorkloadEntry[] = (courseEquivalences ?? []).map(
      (equivalence) => ({
        workload: equivalence?.desiredCourse?.workload,
        statusId: equivalence?.equivalenceStatus?.id
      })
    )

    return calculateWorkloadSummary(entries, curriculumCourses)
  }, [courseEquivalences, curriculumCourses])
}
